export const CONTINGENCY_TYPES_MAPPER = {
    TWOFACTOR: 'authflow/twofactor',
    STEPUP: 'authflow/entry',
    SAFE: 'authflow/safe',
};
